export default (props) => {
    let {
        title,
        labelFunctional,
        textFunctional,
        labelAnalytics,
        textAnalytics,
        labelTracking,
        textTracking,
        labelSave,
        textSuccess,

        analyticsChecked,
        trackingChecked,
    } = props;

    // Fallbacks, inheritances
    if (!labelFunctional) {
        labelFunctional = `Functioneel`;
    }

    if (!labelAnalytics) {
        labelAnalytics = `Analytics`;
    }

    if (!labelTracking) {
        labelFunctional = `Tracking`;
    }

    if (analyticsChecked === undefined) {
        analyticsChecked = false;
    }

    if (trackingChecked === undefined) {
        trackingChecked = false;
    }

    if (!labelSave) {
        labelSave = `Opslaan`;
    }

    if (!textSuccess) {
        textSuccess = `Opgeslagen!`;
    }

    const functionalID = Date.now().toString(18) + Math.random().toString(18).substr(2);
    const analyticsID = Date.now().toString(18) + Math.random().toString(18).substr(2);
    const trackingID = Date.now().toString(18) + Math.random().toString(18).substr(2);

    const parentElement = document.createElement(`div`);
    parentElement.innerHTML = `
    <form class="consent-form">
        ${title ? `<span class="title">${title}</span>` : ``}
        <div class="consentCheckbox">
            <span class="checkboxTitle">${labelFunctional}</span>
            <input type="checkbox" id="${functionalID}" name="functional" disabled checked>
            <label for="${functionalID}">${textFunctional}</label>
        </div>
        <div class="consentCheckbox">
            <span class="checkboxTitle">${labelAnalytics}</span>
            <input type="checkbox" id="${analyticsID}" name="analytics" ${analyticsChecked ? `checked` : ``}>
            <label for="${analyticsID}">${textAnalytics}</label>
        </div>
        <div class="consentCheckbox">
            <span class="checkboxTitle">${labelTracking}</span>
            <input type="checkbox" id="${trackingID}" name="tracking" ${trackingChecked ? `checked` : ``}>
            <label for="${trackingID}">${textTracking}</label>
        </div>
        <div class="saveRow">
            <button class="button" data-save>
                <span>${labelSave}</span>
            </button>
            <span class="successText">${textSuccess}</span>
        </div>
    </form>`;
    return parentElement.firstElementChild;
}